export default "./assets/86a0bf96b8cfb91b56fcc93e02669491.png";